<script setup>
import EntityHistoryView from "@/shared/ui/history/EntityHistoryView.vue";

defineProps({
  selectedRole: {
    type: Object,
    default: () => null,
  },
});
</script>

<template>
  <EntityHistoryView entity-type="role" :entity-id="selectedRole?.code" />
</template>
